import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, User, ExternalLink } from 'lucide-react';

export default function ContactSection() {
  return (
    <section id="kontakt" className="py-16 sm:py-20 lg:py-28 relative" data-testid="contact-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-12">
          <span className="text-xs text-[#46C7FF] uppercase tracking-[0.2em] font-semibold">Kontakt</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mt-2" style={{ fontFamily: 'Space Grotesk' }}>Schreib uns</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1, duration: 0.5 }}
            className="bg-[hsl(0,0%,8%)] border border-white/10 rounded-xl p-6 text-center hover:border-white/20 transition-colors duration-200">
            <div className="w-12 h-12 rounded-full bg-[#CC0000]/10 flex items-center justify-center mx-auto mb-4">
              <User className="w-5 h-5 text-[#CC0000]" />
            </div>
            <h3 className="text-sm font-semibold text-white mb-1">Ansprechpartner</h3>
            <p className="text-sm text-white/60">Norman Bradler</p>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2, duration: 0.5 }}
            className="bg-[hsl(0,0%,8%)] border border-white/10 rounded-xl p-6 text-center hover:border-white/20 transition-colors duration-200">
            <div className="w-12 h-12 rounded-full bg-[#46C7FF]/10 flex items-center justify-center mx-auto mb-4">
              <Mail className="w-5 h-5 text-[#46C7FF]" />
            </div>
            <h3 className="text-sm font-semibold text-white mb-1">E-Mail</h3>
            <a href="mailto:Dresden.devils@gmail.com" className="text-sm text-[#46C7FF] hover:text-[#A9E7FF] transition-colors duration-200 inline-flex items-center gap-1" data-testid="contact-email-link">
              Dresden.devils@gmail.com
              <ExternalLink className="w-3 h-3" />
            </a>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3, duration: 0.5 }}
            className="bg-[hsl(0,0%,8%)] border border-white/10 rounded-xl p-6 text-center hover:border-white/20 transition-colors duration-200">
            <div className="w-12 h-12 rounded-full bg-[#CC0000]/10 flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-5 h-5 text-[#CC0000]" />
            </div>
            <h3 className="text-sm font-semibold text-white mb-1">Adresse</h3>
            <p className="text-sm text-white/60">c/o BSKP<br />Fetscherstraße 29<br />01307 Dresden</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
